import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { Eyebrow, Reveal } from "../site/Reveal";

const U = "https://images.unsplash.com/";
const TILES = [
  { type: "driver", title: "Driver airbags", note: "Steering wheel modules", span: "sm:col-span-2 lg:col-span-8 lg:row-span-2", img: U + "photo-1591388156010-dd522151da35?w=1400&q=80", big: true },
  { type: "passenger", title: "Passenger airbags", note: "Dashboard units", span: "lg:col-span-4", img: U + "photo-1638602030549-d04078ed0b90?w=900&q=80" },
  { type: "knee", title: "Knee airbags", note: "Lower dash", span: "lg:col-span-4" },
  { type: "kit", title: "Complete kits", note: "Dash, modules & belts", span: "sm:col-span-2 lg:col-span-4 lg:row-span-2", img: U + "photo-1542834506-979b3951bc9a?w=1000&q=80", big: true },
  { type: "curtain", title: "Curtain airbags", note: "Roof-line", span: "lg:col-span-4" },
  { type: "side", title: "Side airbags", note: "Door & pillar", span: "lg:col-span-4" },
  { type: "seat", title: "Seat airbags", note: "Seat-mounted", span: "lg:col-span-4" },
  { type: "seatbelt", title: "Belts & SRS", note: "Pretensioners & modules", span: "lg:col-span-4" },
];

const Tile = ({ t, i }) => (
  <Link
    to={`/shop?type=${t.type}`}
    data-testid={`category-tile-${t.type}`}
    className={`group relative flex min-h-[200px] flex-col justify-between overflow-hidden border border-white/10 bg-[#121820] p-6 transition-colors duration-500 hover:border-[#E11D48]/60 ${t.span} ${t.big ? "min-h-[320px] lg:min-h-0" : ""}`}
  >
    {t.img && (
      <>
        <img src={t.img} alt={t.title} loading="lazy" className="absolute inset-0 h-full w-full object-cover opacity-50 grayscale transition-[transform,opacity,filter] duration-700 group-hover:scale-105 group-hover:opacity-70 group-hover:grayscale-0" />
        <div className="absolute inset-0 bg-gradient-to-t from-[#090D12] via-[#090D12]/40 to-transparent" />
      </>
    )}
    <div className="relative flex items-start justify-between">
      <span className="font-mono text-xs text-slate-400">{String(i + 1).padStart(2, "0")}</span>
      <ArrowUpRight className="h-5 w-5 text-slate-400 transition-[transform,color] duration-500 group-hover:-translate-y-1 group-hover:translate-x-1 group-hover:text-[#F43F5E]" />
    </div>
    <div className="relative">
      <p className="font-mono text-xs uppercase tracking-widest text-slate-300">{t.note}</p>
      <h3 className={`mt-2 font-display font-extrabold uppercase leading-[0.9] tracking-tight ${t.big ? "text-5xl sm:text-6xl" : "text-3xl"}`}>{t.title}</h3>
    </div>
  </Link>
);

export const Categories = () => (
  <section id="categories" data-testid="categories-section" className="mx-auto max-w-7xl px-4 py-24 sm:px-8 lg:px-12 lg:py-32">
    <Reveal className="mb-12 flex flex-wrap items-end justify-between gap-6">
      <div>
        <Eyebrow>Browse by position</Eyebrow>
        <h2 className="mt-4 font-display text-5xl font-black uppercase leading-[0.9] tracking-tight sm:text-7xl">Every airbag,<br />every position.</h2>
      </div>
      <Link to="/shop" data-testid="categories-view-all" className="font-mono text-xs uppercase tracking-[0.2em] text-slate-300 underline-offset-8 hover:text-white hover:underline">
        View all parts →
      </Link>
    </Reveal>
    <Reveal>
      <div className="grid grid-cols-1 lg:auto-rows-[200px] gap-3 sm:grid-cols-2 lg:grid-cols-12">
        {TILES.map((t, i) => <Tile key={t.type} t={t} i={i} />)}
      </div>
    </Reveal>
  </section>
);
